<div class="banner parbase aem-GridColumn aem-GridColumn--default--12 bg-coral-medium">
    <section id="sml_ht_home_banner">
        <article class="container" id="top">
            <div class="row">
                <div class="col-md-12 col-sm-12 col-xs-12 padB10 wow fadeInLeft">
                    <div>
                        <h2 class="h2-heading white-color d-inline" style="line-height:30px !important">
                            <!-- <span name="bannerName">Terms and Condition</span> -->
                          
                        </h2>
                    </div>
                </div>
            </div>
        </article>
    </section>
</div>
<div class="applicatinForm">
    <div class="marLR111 mb-5">
            <div class="dpContent">
                    <div class="dpHeading">PRIVACY & DATA PROTECTION</div>
            
                    <div class="dp">Infosys Limited having its registered office at Electronics City, Hosur Road, Bangalore – 560100, including its subsidiaries, associates and affiliated companies (collectively referred to as “Infosys”) has a requirement to collect and process Personal Information (“PI”) or Sensitive Personal Data or Information (“SPDI”), together “Personal Data”, from you (“you/your”) in accordance with the Information Technology (Reasonable security practices and procedures and sensitive personal data or Information) Rules, 2011 (“Rules”). The term PI as used herein shall mean any information that relates to a natural person, which, either directly or indirectly, in combination with other information available or likely to be available with a Body Corporate, is capable of identifying such person.
                    </div>
                    <div class="dpHead"> Personal Information</div>
        <div class="dp"> Infosys will process the following Personal Information collected from you or Karvy, Registrar managing the shares of Infosys.
            <br/> • Name
            <br/> • User ID
            <br/> • Password
            <br/> • DP ID
            <br/> • Folio/Client ID
            <br/> • PAN
            <br/> • All Demat accounts linked to the PAN
            <br/> • Category: Resident/ Non- Resident of India
            <br/> • Legal Status
            <br/> • In case of Non-Resident, the Country of residence
            <br/> • Email Id
            <br/> • Address
            <br/> • Contact Details
            <br/> • No. of Shares
            <br/> • Gross Dividend
            <br/> • Currency
            <br/> •	In case of Joint Shareholder, name of the Joint Shareholder.  
            <br/> In addition, the forms you upload for tax waiver, or exemption and other requirements as per the laws of the land, which may include Personal Information such as DOB, Estimated Income, PIN Code/Zip Code etc.
        </div>

        <div class="dpHead"> Purpose of Processing</div>
        <div class="dp"> Infosys would hereinafter be required to process Personal Information for purpose of administering tax deduction on source for dividends paid out by Infosys to its shareholders and comply with legal obligations arising under applicable laws and regulations.
        </div>
        <div class="dpHead"> Data Recipients</div>
        <div class="dp"> Your data will be accessible by authorized users at Infosys, and disclosed to tax consultants, auditors, government and tax authorities
        </div>
        <div class="dpHead"> Data transfer</div>
        <div class="dp"> Your personal information will be collected and processed in India and will be stored on our servers and infrastructures located with our cloud vendors located in India.
        </div>
        <div class="dpHead"> Security Measures</div>
        <div class="dp"> Infosys commits to implementing reasonable and appropriate safeguards to prevent unauthorized access, unlawful processing, unauthorized or accidental loss or destruction of the Personal Information.
        </div>
        <div class="dpHead"> Retention Period</div>
        <div class="dp"> Personal Information that is no longer required to be retained as per legal and business requirements will be disposed in a secure manner.
        </div>
        <div class="dpHead"> Your Rights </div>
        <div class="dp"> You are entitled at any time to correct or amend the Personal Information if found to be inaccurate or deficient as feasible.  Such requests will be fulfilled subject to not conflicting with other applicable laws.  For any concerns or queries you may reach out to <a href="dividend.tax@infosys.com">dividend.tax&#64;infosys.com</a></div>
        <div class="dpHead"> How to Contact Us </div>
        <div class="dp"> If you have any questions regarding our privacy practices or this privacy statement, please contact us at:
                <address>
                        Contact person: Srinivas P.<br>
                        Contact address: Data Privacy Office, Infosys Limited, Electronics City, Hosur Road, Bangalore<br>
                        560 100, India<br>
                        Phone: +91 80 2852 0261<br>
                        Email: <a href="privacy@infosys.com">privacy&#64;infosys.com</a>
                </address>
        </div>
        <div class="dpHead"> Version 1.3</div>
        <div class="dp"></div>
        
                    <div class="dpHead"> Updates to this privacy statement</div>
                    <div class="dp">Infosys may change the data privacy practices and update this privacy statement as and when the need arises, and the same will be made available on the portal, but our commitment to protect the privacy of users will continue to remain.</div>

                    <div class="dp"> In pursuance of the foregoing, you hereby acknowledge and understand that the Personal Information may be processed in the above-mentioned manner and hereby consent to such processing. Additionally, you also acknowledge that any personal information of other individuals, if any, is shared by you only after seeking consent from the person to whom the personal information belongs.</div>       
                 </div>
    </div>
</div>
